import { render, staticRenderFns } from "./CompetencyMatriz.vue?vue&type=template&id=4a37ec43&scoped=true"
import script from "./CompetencyMatriz.vue?vue&type=script&lang=js"
export * from "./CompetencyMatriz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a37ec43",
  null
  
)

export default component.exports